import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MailCheck, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 p-6 neec-grid-bg">
      <div className="w-full max-w-sm bg-card border border-border rounded-3xl p-8 shadow-2xl" data-testid="forgot-panel">
        <div className="flex items-center gap-2.5 mb-6">
          <div className="w-10 h-10 rounded-xl bg-emerald-500 flex items-center justify-center text-white font-head font-extrabold">N</div>
          <p className="font-head font-extrabold text-lg">NEEC POS</p>
        </div>
        {sent ? (
          <div className="text-center py-6" data-testid="forgot-sent">
            <div className="w-14 h-14 rounded-2xl bg-emerald-500/10 text-emerald-500 flex items-center justify-center mx-auto mb-4"><MailCheck className="w-7 h-7" /></div>
            <h2 className="font-head text-2xl font-extrabold">Check your email</h2>
            <p className="text-muted-foreground mt-2 mb-6">If that email is registered, we've sent a secure, single-use link to reset your password.</p>
            <Link to="/login" className="text-sm text-emerald-500 hover:underline inline-flex items-center gap-1"><ArrowLeft className="w-4 h-4" /> Back to sign in</Link>
          </div>
        ) : (
          <>
            <h2 className="font-head text-2xl font-extrabold">Forgot your password?</h2>
            <p className="text-muted-foreground mt-1 mb-6 text-sm">Enter your login email and we'll send you a secure reset link. We never email your password.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="text-xs font-semibold uppercase tracking-wider">Email</Label>
                <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" className="h-12 mt-1.5" data-testid="forgot-email" />
              </div>
              {error && <p className="text-sm text-rose-500" data-testid="forgot-error">{error}</p>}
              <Button type="submit" disabled={loading} className="w-full h-12 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold" data-testid="forgot-submit">
                {loading ? "Sending…" : "Send Reset Link"}
              </Button>
            </form>
            <div className="mt-6 text-center">
              <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-1"><ArrowLeft className="w-4 h-4" /> Back to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
